/** 价格列表四项筛选；空字符串表示不限制该维度（docs/04）。 */
export interface PriceFilterValues {
  ownerId: string;
  entityId: string;
  mcc: string;
  mnc: string;
}

/** 客户与通道价格使用相同的初始筛选。 */
export const EMPTY_PRICE_FILTERS: PriceFilterValues = { ownerId: "", entityId: "", mcc: "", mnc: "" };

/** 在分页之前组合筛选；MNC 按数字串精确比较，保留前导零。 */
export function matchesPriceFilters(filters: PriceFilterValues, price: { mcc: string; mnc: string | null }, entityId: number, ownerId?: number) {
  return (!filters.ownerId || String(ownerId) === filters.ownerId)
    && (!filters.entityId || String(entityId) === filters.entityId)
    && (!filters.mcc.trim() || price.mcc === filters.mcc.trim())
    && (!filters.mnc.trim() || price.mnc === filters.mnc.trim());
}
